<template>
  <el-main class="chart">
    <el-row type="flex">
      <el-select style="margin-right: 10px;" v-model="organizationId" v-if="user.type !== 'normal'"
        :disabled="loading"
        @change="getAllUserAccountId"
      >
        <el-option
          key="all"
          :label="$t('default.allOrganization')"
          value="all">{{$t('default.allOrganization')}}
        </el-option>
        <el-option
          v-for="or in organizations"
          :key="or._id"
          :value="or._id"
          :label="or.name">
        </el-option>
      </el-select>
      <el-select v-if="user.type !== 'normal'" style="margin-right: 10px;"  filterable v-model="accountId"
      :disabled="loading">
        <el-option
          key=""
          :label="$t('default.allAccount')"
          value="all">{{$t('default.allAccount')}}
        </el-option>
        <el-option
          v-for="account in accountIds"
          :key="account._id"
          :value="account._id"
          :label="account.username">
        </el-option>
      </el-select>
      <el-date-picker
        style="margin-right: 10px;"
        v-model="pickerDate"
        type="daterange"
        :disabled="loading"
        :range-separator="$t('default.to')"
        :start-placeholder="$t('default.startDate')"
        :end-placeholder="$t('default.endDate')">
      </el-date-picker>
      <el-button
        :disabled="loading"
        style="margin-right: 10px;" width="100px;" type="primary" @click="saveData(false)">{{$t('default.view')}}</el-button>
      <el-button
        :disabled="loading || (!!organizationId && organizationId !== 'all')
        || (!!accountId && accountId !== 'all')"
        v-if="user.type === 'admin'"
        style="margin-right: 10px;" width="100px;" type="primary" @click="saveData(true)">{{$t('default.copyButton')}}</el-button>
    </el-row>
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t('default.gradeNums') }}</span>
      </div>
      <el-table v-loading="loading" :data="dayData">
        <el-table-column prop="type" :label="$t('default.chartTotal')" >
        </el-table-column>
        <el-table-column prop="day" :label="$t('default.toDay')" >
        </el-table-column>
        <el-table-column prop="week" :label="$t('default.thisWeek')" >
        </el-table-column>
        <el-table-column prop="month" :label="$t('default.thisMonth')" >
        </el-table-column>
        <el-table-column prop="quarter" :label="$t('default.thisQuarter')" >
        </el-table-column>
        <el-table-column prop="year" :label="$t('default.thisYear')" >
        </el-table-column>
        <el-table-column prop="total" :label="$t('default.HistoryTotal')" >
        </el-table-column>
        <el-table-column prop="picker" :label="$t('default.datepicker')" >
        </el-table-column>
      </el-table>
    </el-card>
    <!-- <el-card>
      <div slot="header" class="clearfix">
        <span>阅片结果统计</span>
      </div>
      <el-table v-loading="loading" :data="resultData">
        <el-table-column width="200px" prop="name" label="分类" >
        </el-table-column>
        <el-table-column prop="dr" label="糖尿病性视网膜病变">
        </el-table-column>
        <el-table-column prop="drnp" label="糖尿病性视网膜病变(drnp)">
        </el-table-column>
        <el-table-column prop="glaucoma" label="青光眼">
        </el-table-column>
        <el-table-column prop="cataract" label="重度白内障">
        </el-table-column>
        <el-table-column prop="amd" label="年龄相关性黄斑变性">
        </el-table-column>
      </el-table>
    </el-card> -->
    <!-- <el-card v-if="user.type === 'admin'">
      <div style="display: inline-block;width: 70%">
        <ve-histogram :data="chartData"></ve-histogram>
      </div>
      <div style="display: inline-block;width: 30%">
        <ve-pie :data="pieData"></ve-pie>
      </div>
    </el-card> -->
  </el-main>
</template>

<style>
.chart .el-card{
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  data () {
    return {
      message: null,
      loading: false,
      reportVisible: false,
      mode: 'ai',
      list: [],
      pickerDate: null,
      gradings: [],
      resultData: [],
      dayData: [],
      recordDate: moment().startOf('day'),
      accountId: '',
      accountIds: [],
      accountIdMap: {},
      organizationId: 'all',
      organizations: [],
      organizationsMap: {},
      diseasesMap: {
        dr: this.$t('default.dr'),
        amd: this.$t('default.amd'),
        cataract: this.$t('default.cataract'),
        glaucoma: this.$t('default.glaucoma'),
        drnp: this.$t('default.drnp')
      },
      cvdMap: {
        ungradable: this.$t('default.ungradable'),
        mid: this.$t('default.medium_risk'),
        high: this.$t('default.high_risk'),
        low: this.$t('default.low_risk'),
        NA: 'NA'
      },
      chartData: {
        columns: ['分类', this.$t('default.dr'), this.$t('default.glaucoma'), this.$t('default.cataract'), this.$t('default.amd')],
        rows: []
      },
      pieData: {
        columns: ['分类', '数量'],
        rows: []
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  mounted: async function () {
    await this.getAllUserAccountId()
    await this.getAllOrganizations()
    if (this.user.type === 'admin') {
      this.saveData(true)
    } else {
      this.saveData(false)
    }
  },
  methods: {
    async getAllUserAccountId () {
      let result = {}
      try {
        result = await this.$store.dispatch('getAllUserAccountId', {
          organizationId: this.organizationId
        })
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.accountIds = data.users
        this.accountIds.map((account) => {
          this.accountIdMap[account._id] = account.username
        })
      }
    },
    async getAllOrganizations () {
      let result = {}
      try {
        result = await this.$store.dispatch('getAllOrganizations')
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.organizations = data.organizations
        this.organizations.map((account) => {
          this.organizationsMap[account._id] = account.name
        })
      }
    },
    getResultData (dayMaps, timeMap) {
      this.dayData = []
      this.resultData = []
      this.chartData.rows = []
      this.pieData.rows = []
      const resultData = {}
      const cvdResultData = {
        ungradable: 0,
        NA: 0,
        low: 0,
        mid: 0,
        high: 0
        // total: 0
      }
      const eyes = ['od', 'os']
      let diseases = ['drnp', 'cataract', 'glaucoma', 'amd']
      const grading = ['negative', 'positive', 'ungradable']
      const tableNameMap = {
        os: {
          negative: this.$t('default.osnegative'),
          positive: this.$t('default.ospositive'),
          ungradable: this.$t('default.osungradable')
        },
        od: {
          negative: this.$t('default.odnegative'),
          positive: this.$t('default.odpositive'),
          ungradable: this.$t('default.odungradable')
        }
      }
      eyes.forEach((eye) => {
        resultData[eye] = {}
        grading.forEach((g) => {
          const doc = { eye: eye, grading: g, dr: 0, amd: 0, glaucoma: 0, cataract: 0, drnp: 0 }
          doc.name = tableNameMap[eye][g]
          resultData[eye][g] = doc
        })
      })
      const defaultData = {
        day: 0,
        week: 0,
        month: 0,
        quarter: 0,
        year: 0,
        total: 0,
        picker: 0
      }
      const totalData = _.cloneDeep(defaultData)
      const negativeData = _.cloneDeep(defaultData)
      const positiveData = _.cloneDeep(defaultData)
      const halfgradbleData = _.cloneDeep(defaultData)
      const ungradableData = _.cloneDeep(defaultData)
      const usableData = _.cloneDeep(defaultData)
      const positivePersentData = _.cloneDeep(defaultData)
      totalData.type = this.$t('default.totalData')
      totalData.total = this.gradings.length
      negativeData.type = this.$t('default.negativeData')
      positiveData.type = this.$t('default.positiveData')
      halfgradbleData.type = this.$t('default.halfgradbleData')
      ungradableData.type = this.$t('default.ungradableData')
      usableData.type = this.$t('default.usableData')
      positivePersentData.type = this.$t('default.positivePersentData')
      const timeArr = ['day', 'week', 'month', 'quarter', 'year', 'picker']
      this.gradings.forEach((grading) => {
        let ungradableNumsFlag = 3
        if (!grading.od.result || !grading.os.result) {
          if (grading.reportType === 'all') {
            ungradableNumsFlag = 2
          } else {
            ungradableNumsFlag = 1
          }
        }
        const gradedAt = moment(grading.createdAt)
        let ungradableNums = 0
        let negativeNums = 0
        let positiveNums = 0
        let diseasesNums = 0
        let NA = false
        if (grading.reportType === 'all' || grading.reportType === 'vessel') {
          diseasesNums++
          // cvdResultData.total++
          let od = grading.od.result && grading.od.result.cvd && grading.od.result.cvd.who_pred
          let os = grading.os.result && grading.os.result.cvd && grading.os.result.cvd.who_pred
          const odQuality = grading.od && grading.od.result && grading.od.result.public && grading.od.result.public.quality
          const osQuality = grading.os && grading.os.result && grading.os.result.public && grading.os.result.public.quality
          if (!grading.od.result || !grading.os.result) {
            if (grading.reportType === 'all') {
              if (odQuality === 'Reject' || osQuality === 'Reject' ||
                (osQuality && typeof osQuality === 'object' && osQuality.indexOf('Gradable') === -1) || (odQuality && typeof odQuality === 'object' && odQuality.indexOf('Gradable') === -1)) {
                cvdResultData.ungradable++
                ungradableNums++
              }
            } else {
              if (odQuality === 'Reject' || osQuality === 'Reject' ||
                (osQuality && typeof osQuality === 'object' && osQuality.indexOf('Gradable') === -1) || (odQuality && typeof odQuality === 'object' && odQuality.indexOf('Gradable') === -1)) {
                cvdResultData.ungradable++
                ungradableNums++
              }
            }
          } else {
            if ((odQuality === 'Reject' && osQuality === 'Reject') ||
              ((osQuality && typeof osQuality === 'object' && osQuality.indexOf('Gradable') === -1) && (odQuality && typeof odQuality === 'object' && odQuality.indexOf('Gradable') === -1)) || (!os && !od)) {
              cvdResultData.ungradable++
              ungradableNums++
            }
          }
          if ((odQuality === 'Reject' && osQuality === 'Reject') ||
            ((osQuality && typeof osQuality === 'object' && osQuality.indexOf('Gradable') === -1) && (odQuality && typeof odQuality === 'object' && odQuality.indexOf('Gradable') === -1)) || (!os && !od)) {
            // cvdResultData.ungradable++
            // ungradableNums++
            // 和上面条件重复
          } else {
            if (osQuality === 'Reject' || (osQuality && typeof osQuality === 'object' && osQuality.indexOf('Gradable') === -1)) {
              os = null
            }
            if (odQuality === 'Reject' || (odQuality && typeof odQuality === 'object' && odQuality.indexOf('Gradable') === -1)) {
              od = null
            }
            if (grading.age < 40 || grading.age > 80) {
              NA = true
              negativeNums++
              cvdResultData.NA++
            } else {
              let average = 0
              if (od === null) {
                average = (os)
              }
              if (os === null) {
                average = (od)
              }
              if (od && os) {
                if ((od - os) < -9 || (od - os) > 11) {
                  NA = true
                  ungradableNums++
                  cvdResultData.NA++
                } else {
                  average = ((od + os) / 2)
                }
              }
              if (!NA) {
                if (average < 10) {
                  cvdResultData.low++
                  negativeNums++
                }
                if (average >= 10 && average < 20) {
                  cvdResultData.mid++
                  positiveNums++
                }
                if (average >= 20) {
                  cvdResultData.high++
                  positiveNums++
                }
              }
            }
          }
        }
        if (grading.reportType !== 'vessel') {
          if (grading.reportType === 'test') {
            diseases = ['drnp', 'glaucoma', 'amd']
          } else {
            diseases = ['drnp', 'cataract', 'glaucoma']
          }
          eyes.forEach((eye) => {
            diseases.forEach((disease) => {
              if (grading[eye].result && grading[eye].result[disease]) {
                diseasesNums++
                if (disease === 'glaucoma') {
                  if (grading[eye].result && grading[eye].result[disease] && grading[eye].result[disease].grading !== '') {
                    if (grading[eye].result[disease].grading === 'ungradable') {
                      ungradableNums++
                      resultData[eye].ungradable[disease]++
                    } else if (grading[eye].result[disease].grading === 'negative') {
                      negativeNums++
                      resultData[eye].negative[disease]++
                    } else if (grading[eye].result[disease].grading === 'low risk') {
                      negativeNums++
                      resultData[eye].negative[disease]++
                    } else {
                      positiveNums++
                      resultData[eye].positive[disease]++
                    }
                  }
                } else if (disease === 'amd') {
                  if (grading[eye].result && grading[eye].result[disease] && grading[eye].result[disease].grading !== '') {
                    if (grading[eye].result[disease].grading === 'ungradable') {
                      ungradableNums++
                      resultData[eye].ungradable[disease]++
                    } else if (grading[eye].result[disease].grading === 'negative') {
                      negativeNums++
                      resultData[eye].negative[disease]++
                    } else {
                      positiveNums++
                      resultData[eye].positive[disease]++
                    }
                  }
                } else if (disease === 'cataract') {
                  if (grading[eye].result && grading[eye].result[disease] && grading[eye].result[disease].grading !== '') {
                    if (grading[eye].result[disease].grading === 'ungradable' || (grading[eye].result.public &&
                      grading[eye].result.public.quality === 'Reject')) {
                      ungradableNums++
                      resultData[eye].ungradable[disease]++
                    } else {
                      if (grading[eye].result[disease].grading === 'negative') {
                        negativeNums++
                        resultData[eye].negative[disease]++
                      }
                      if (grading[eye].result[disease].grading === 'positive') {
                        positiveNums++
                        resultData[eye].positive[disease]++
                      }
                    }
                  }
                } else {
                  if (grading[eye].result && grading[eye].result[disease] && grading[eye].result[disease].grading !== '') {
                    if (grading[eye].result[disease].grading === 'ungradable') {
                      ungradableNums++
                      resultData[eye].ungradable[disease]++
                    }
                    if (grading[eye].result[disease].grading === 'negative') {
                      negativeNums++
                      resultData[eye].negative[disease]++
                    }
                    if (grading[eye].result[disease].grading === 'positive') {
                      positiveNums++
                      resultData[eye].positive[disease]++
                    }
                  }
                }
              }
            })
          })
        }
        if (this.pickerDate && this.pickerDate.length > 0) {
          this.pickerDate[1] = moment(this.pickerDate[1]).endOf('day').toDate()
        }
        // 备份历史数据
        if (dayMaps) {
          const gradedAtStr = gradedAt.format('YYYY-MM-DD')
          if (gradedAt.isBefore(this.recordDate) && dayMaps[grading.accountId][gradedAtStr]) {
            dayMaps[grading.accountId][gradedAtStr].totalData++
            if (diseasesNums > 0) {
              if (diseasesNums === negativeNums) {
                dayMaps[grading.accountId][gradedAtStr].negativeData++
              }
            }
            if (positiveNums > 0) {
              dayMaps[grading.accountId][gradedAtStr].positiveData++
            } else {
              if (grading.reportType === 'vessel') {
                if (ungradableNums === 1) {
                  dayMaps[grading.accountId][gradedAtStr].ungradableData++
                }
              } else {
                if (ungradableNums <= ungradableNumsFlag && ungradableNums > 0) {
                  dayMaps[grading.accountId][gradedAtStr].halfgradbleData++
                }
                if (ungradableNums > ungradableNumsFlag || (ungradableNums >= diseasesNums)) {
                  dayMaps[grading.accountId][gradedAtStr].ungradableData++
                }
              }
            }
          }
        }
        // end
        timeArr.forEach((time) => {
          if (time !== 'picker') {
            const toDay = moment()
            const startedAt = toDay.startOf(time)
            if (gradedAt.isAfter(startedAt)) {
              totalData[time]++
            }
          } else {
            if (this.pickerDate && this.pickerDate.length > 0) {
              if (gradedAt.isAfter(moment(this.pickerDate[0])) && gradedAt.isBefore(moment(this.pickerDate[1]))
              ) {
                totalData[time]++
              }
            }
          }
        })
        if (diseasesNums > 0) {
          if (diseasesNums === negativeNums) {
            negativeData.total++
            timeArr.forEach((time) => {
              if (time !== 'picker') {
                const toDay = moment()
                const startedAt = toDay.startOf(time)
                if (gradedAt.isAfter(startedAt)) {
                  negativeData[time]++
                }
              } else {
                if (this.pickerDate && this.pickerDate.length > 0) {
                  if (gradedAt.isAfter(moment(this.pickerDate[0])) && gradedAt.isBefore(moment(this.pickerDate[1]))
                  ) {
                    negativeData[time]++
                  }
                }
              }
            })
          }
          if (positiveNums > 0) {
            positiveData.total++
            timeArr.forEach((time) => {
              if (time !== 'picker') {
                const toDay = moment()
                const startedAt = toDay.startOf(time)
                if (gradedAt.isAfter(startedAt)) {
                  positiveData[time]++
                }
              } else {
                if (this.pickerDate && this.pickerDate.length > 0) {
                  if (gradedAt.isAfter(moment(this.pickerDate[0])) && gradedAt.isBefore(moment(this.pickerDate[1]))
                  ) {
                    positiveData[time]++
                  }
                }
              }
            })
          } else {
            if (grading.reportType === 'vessel') {
              if (ungradableNums === 1) {
                ungradableData.total++
                timeArr.forEach((time) => {
                  if (time !== 'picker') {
                    const toDay = moment()
                    const startedAt = toDay.startOf(time)
                    if (gradedAt.isAfter(startedAt)) {
                      ungradableData[time]++
                    }
                  } else {
                    if (this.pickerDate && this.pickerDate.length > 0) {
                      if (gradedAt.isAfter(moment(this.pickerDate[0])) && gradedAt.isBefore(moment(this.pickerDate[1]))
                      ) {
                        ungradableData[time]++
                      }
                    }
                  }
                })
              }
            } else {
              if (ungradableNums <= ungradableNumsFlag && ungradableNums > 0) {
                halfgradbleData.total++
                timeArr.forEach((time) => {
                  if (time !== 'picker') {
                    const toDay = moment()
                    const startedAt = toDay.startOf(time)
                    if (gradedAt.isAfter(startedAt)) {
                      halfgradbleData[time]++
                    }
                  } else {
                    if (this.pickerDate && this.pickerDate.length > 0) {
                      if (gradedAt.isAfter(moment(this.pickerDate[0])) && gradedAt.isBefore(moment(this.pickerDate[1]))
                      ) {
                        halfgradbleData[time]++
                      }
                    }
                  }
                })
              }
              if (ungradableNums > ungradableNumsFlag || (ungradableNums >= diseasesNums)) {
                ungradableData.total++
                timeArr.forEach((time) => {
                  if (time !== 'picker') {
                    const toDay = moment()
                    const startedAt = toDay.startOf(time)
                    if (gradedAt.isAfter(startedAt)) {
                      ungradableData[time]++
                    }
                  } else {
                    if (this.pickerDate && this.pickerDate.length > 0) {
                      if (gradedAt.isAfter(moment(this.pickerDate[0])) && gradedAt.isBefore(moment(this.pickerDate[1]))
                      ) {
                        ungradableData[time]++
                      }
                    }
                  }
                })
              }
            }
          }
        } else {
          console.log('no result')
          console.log(grading)
        }
      })
      for (const eye in resultData) {
        for (const g in resultData[eye]) {
          this.resultData.push(resultData[eye][g])
          const doc = _.cloneDeep(resultData[eye][g])
          diseases.forEach((disease) => {
            doc[this.diseasesMap[disease]] = doc[disease]
          })
          doc['分类'] = doc.name
          this.chartData.rows.push(doc)
        }
      }
      for (const g in cvdResultData) {
        const doc = {
          分类: this.cvdMap[g],
          数量: cvdResultData[g]
        }
        this.pieData.rows.push(doc)
      }
      timeArr.push('total')
      if (timeMap) {
        timeArr.forEach((time) => {
          if (timeMap[time][0]) {
            const oldData = timeMap[time][0]
            negativeData[time] = negativeData[time] + oldData.negativeData
            positiveData[time] = positiveData[time] + oldData.positiveData
            halfgradbleData[time] = halfgradbleData[time] + oldData.halfgradbleData
            ungradableData[time] = ungradableData[time] + oldData.ungradableData
            totalData[time] = totalData[time] + oldData.totalData
          }
        })
      }
      timeArr.forEach((time) => {
        if (totalData[time] === 0) {
          usableData[time] = '0%'
          positivePersentData[time] = '0%'
        } else {
          usableData[time] = (((totalData[time] - ungradableData[time]) / totalData[time]) * 100).toFixed(2) + '%'
          positivePersentData[time] = (positiveData[time] / totalData[time] * 100).toFixed(2) + '%'
        }
      })
      // usableData.total = (((totalData.total - ungradableData.total) / totalData.total) * 100).toFixed(2) + '%'
      // positivePersentData.total = (positiveData.total / totalData.total * 100).toFixed(2) + '%'
      /// 当前数据
      const tableDataTemp = [negativeData, positiveData, halfgradbleData, ungradableData, usableData, positivePersentData, totalData]
      this.dayData = tableDataTemp
      if (dayMaps) {
        // 是否备份数据
        this.saveRecords(dayMaps)
      }
    },
    async saveRecords (dayMaps) {
      for (const id in dayMaps) {
        const records = []
        const accountData = dayMaps[id]
        for (const date in accountData) {
          const obj = accountData[date]
          obj.accountId = id
          obj.formatDate = moment(obj.recordedAt).format('YYYY-MM-DD')
          records.push(obj)
        }
        if (records.length > 0) {
          try {
            await this.$store.dispatch('saveRecords', {
              records
            })
          } catch (err) {
            this.loading = false
            return false
          }
        }
      }
      try {
        const recordDate = _.cloneDeep(this.recordDate)
        await this.$store.dispatch('saveRecordHistory', {
          recordedAt: recordDate.subtract(1, 'day').toDate()
        })
      } catch (err) {
        this.loading = false
        return false
      }
      this.message.close()
      this.$message({
        message: '备份已完成',
        type: 'success'
      })
    },
    async saveData (save) {
      console.log(`是否需要备份： ${save}`)
      this.loading = true
      // if recordedat < 昨天
      let recordResult = {}
      const recordsDoc = {
        organizationId: this.organizationId,
        accountId: this.accountId
      }
      if (this.pickerDate && this.pickerDate.length > 0) {
        recordsDoc.startDate = moment(this.pickerDate[0]).toDate()
        recordsDoc.endDate = moment(this.pickerDate[1]).toDate()
      }
      try {
        recordResult = await this.$store.dispatch('getRecords', recordsDoc)
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const timeMap = recordResult.data.data.timeMap
      let startDate = moment('2021-01-01')
      // 制作备份数据的开始日期 为最后一次备份数据第二日开始
      let lastRecordResult = null
      try {
        lastRecordResult = await this.$store.dispatch('getLastHistory')
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const lastRecord = lastRecordResult.data.data.record
      if (lastRecord.length > 0) {
        startDate = moment(lastRecord[0].recordedAt).add(1, 'days')
        console.log(startDate.toDate())
      }
      let dayMaps = null
      let gradingDoc = {
        mode: 'ai',
        organizationId: this.organizationId,
        accountId: this.accountId,
        state: 'graded',
        startDate: startDate.toDate()
      }
      // 是否要备份数据
      if (save) {
        this.message = this.$message({
          message: '正在备份数据中....',
          duration: 0
        })
        dayMaps = {}
        // 需要获取所有用户的数据进行备份
        gradingDoc = {
          mode: 'ai',
          state: 'graded',
          startDate: startDate.toDate()
        }
        let accounts = {}
        let accountIds = []
        try {
          accounts = await this.$store.dispatch('getAllUserAccountId')
        } catch (err) {
          console.log(err)
          this.loading = false
          return false
        }
        accountIds = accounts.data.data.users
        const today = this.recordDate
        const days = today.diff(startDate, 'days')
        for (let a = 0; a < accountIds.length; a++) {
          const id = accountIds[a]._id
          dayMaps[id] = {}
          // i =1 代表不备份今日数据 从昨日开始
          for (let i = 1; i <= days; i++) {
            const recordDate = _.cloneDeep(this.recordDate)
            const date = recordDate.subtract(i, 'days')
            const dateKey = date.format('YYYY-MM-DD')
            dayMaps[id][dateKey] = {
              negativeData: 0,
              positiveData: 0,
              halfgradbleData: 0,
              ungradableData: 0,
              usableData: 0,
              positivePersentData: 0,
              totalData: 0,
              recordedAt: date.toDate(),
              createdAt: new Date()
            }
          }
        }
      }
      let result = {}
      try {
        result = await this.$store.dispatch('getAllGradings', gradingDoc)
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.gradings = data.gradings
        this.total = data.total
        this.getResultData(dayMaps, timeMap)
      }
      this.loading = false
    },
    async getList () {
      this.loading = true
      let result = {}
      try {
        result = await this.$store.dispatch('getAllGradings', {
          mode: 'ai',
          organizationId: this.organizationId,
          accountId: this.accountId,
          state: 'graded'
        })
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.gradings = data.gradings
        this.total = data.total
        this.getResultData()
      }
      this.loading = false
    }
  }
}
</script>
